import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NodesService } from '../services/nodes.service';

@Component({
  selector: 'dialog-fusion',
  templateUrl: './dialog-fusion.component.html',
  styleUrls: ['./dialog-fusion.component.scss']
})
export class DialogFusionComponent implements OnInit {
  loading =false;
  public name :string="";
  constructor(  @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DialogFusionComponent>, private nodeService: NodesService) { }

  ngOnInit(): void {
  }


  onValidate() {
    this.loading = true;
     const dataToSend ={
      targetFolder:this.data.targetFolder,
      targetFileName:this.name,
      docs:this.data.docs
     }
   this.nodeService.mergeDocuments(dataToSend).then((res)=>{
    this.dialogRef.close(res);
  
   }).finally(() => (this.loading = false));
    
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
